import { render, staticRenderFns } from "./SkinChipLinkRustlabs.vue?vue&type=template&id=807a099a&scoped=true&"
import script from "./SkinChipLinkRustlabs.vue?vue&type=script&lang=ts&"
export * from "./SkinChipLinkRustlabs.vue?vue&type=script&lang=ts&"
import style0 from "./SkinChipLinkRustlabs.vue?vue&type=style&index=0&id=807a099a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807a099a",
  null
  
)

export default component.exports